import { nanoid } from "nanoid";

export const createMessageBoxSlice = (set) => ({
  // stack: for multi message instance
  stack: [],

  // new message will be pushed onto the stack
  //
  // type: 'confirm' | 'alert' | 'error' | 'prompt'
  // 같은 알림이 이미 떠 있으면 새로 쌓지 않고 기존 것에 합친다.
  // 이때 responseHandler 를 이어 붙이는 이유: 합쳐서 버리면 그 호출을 await 한 쪽이
  // 영원히 resolve 되지 않는다.
  //
  // 단, confirm/prompt 는 절대 합치지 않는다. 문구가 같아도 각각 다른 대상에 대한
  // 별개의 결정이다 — 노드 A와 노드 B의 "서비스를 종료하시겠습니까?" 를 합치면
  // 한 번의 확인으로 둘 다 종료된다.
  pushMessage: ({ type, title, description, time, responseHandler }) => {
    let id = null;
    set((state) => {
      const mergeable = type !== "confirm" && type !== "prompt";
      const duplicated =
        mergeable &&
        state.messageBox.stack.find(
          (msg) =>
            msg.type === type &&
            msg.title === title &&
            msg.description === description
        );

      if (duplicated) {
        id = duplicated.id;
        const previousHandler = duplicated.responseHandler;
        duplicated.responseHandler = (result) => {
          previousHandler(result);
          responseHandler(result);
        };
        return;
      }

      id = nanoid();
      state.messageBox.stack.push({
        id,
        type,
        title,
        description,
        time,
        responseHandler,
      });
    });
    return id;
  },

  // remove the id when the message is closed
  popMessage: (id) => {
    set((state) => {
      state.messageBox.stack = state.messageBox.stack.filter(
        (msg) => msg.id !== id
      );
    });
  },
});
